import { atom } from 'jotai';

export const pageAtom = atom(1);
